import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Button, Chip, IconButton, Stack, Tooltip } from '@mui/material';
import { Delete, InsertDriveFile, PendingActionsOutlined } from '@mui/icons-material';
import 'moment/locale/id';
import { useNavigate } from 'react-router-dom';
import { ButtonContained } from 'shared/components/Button';
import DialogListApprovalSK from '../../../Dialog/DialogListApprovalSK';
import { useSelector, useDispatch } from 'react-redux';
import { StyledTableCell, StyledTableRow } from 'shared/components/Table';
import { blue, grey, indigo, red, yellow } from '@mui/material/colors';
import DialogListRiwayat from 'pages/sample/DigitalSign/Dialog/DialogListRiwayat';
import { useAuthUser } from '@crema/utility/AuthHooks';
import DialogKonfirmasi from 'shared/components/DialogKonfirmasi'
import moment from 'moment';
import { onDeleteDocumentDigisign } from 'redux/actions/DigitalSign';

const ListViewItem = ({
  key,
  index,
  id,
  data,
  selectedRow,
  setSelectedRow,
  handleShowAttachment,
  no,
  tipeDokumen,
  isCreate,
  isMonitoring,
  setRefresh,
}) => {
  const [open, setOpen] = useState(false)
  const [openModalDelete, setOpenModalDelete] = useState(false)
  const [openListRiwayat, setOpenListRiwayat] = useState(false)

  const dispatch = useDispatch()
  const navigation = useNavigate();
  const { user } = useAuthUser()

  const { filter } = useSelector((state) => state.digiSign);
  const isBulk = user.roles_coofis.some(item => item.state === 'BULK_DIGISIGN')

  const handleOpenListApproval = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleCheckbox = (params, data) => {
    const extRow = [...selectedRow];
    const idx = extRow.findIndex((x) => x === data.id);

    if (idx > -1 && !params.target.checked) extRow.splice(idx, 1);
    else extRow.push(data.id);
    setSelectedRow(extRow);
  };

  const handleGetDetail = (e, data) => {
    e.stopPropagation();
    if (
      filter === 'composer' ||
      data.state === 'done' ||
      data.state === 'need_sign' ||
      data.state === 'need_approval' ||
      data.state === 'reject' ||
      data.state === 'need_release' ||
      data.state === 'release'
    ) {
      navigation(`/apps/dokumen-sk/detail/${tipeDokumen}/${id}`);
    } else {
      navigation(`/apps/dokumen-sk/tambah-dokumen/${tipeDokumen}/${id}`);
    }
  };

  const handleOpenListRiwayat = (e) => {
    e.stopPropagation()
    setOpenListRiwayat(true);
  }

  const handleGetDateParaf = () => {
    const find = data.logs && data.logs.find(x => x.user.toUpperCase() === user.nama.toUpperCase() && x.action === 'approve')

    return find ? moment(find.created_at).format('DD/MM/YYYY') : '-'
  }

  const handleDelete = (status = 0) => {
    if (status === 1) {
      dispatch(onDeleteDocumentDigisign(setRefresh, data.id))
    }

    setOpenModalDelete(false)
  }

  return (
    <>
      <StyledTableRow key={key} onClick={(e) => handleGetDetail(e, data)}>
        {filter == 'sk-need-sign' && isBulk && (
          <StyledTableCell align='center' onClick={(e) => e.stopPropagation()}>
            <input
              onChange={(e) => handleCheckbox(e, data)}
              type='checkbox'
              value={data.id}
              checked={selectedRow.includes(data.id)}
            />
          </StyledTableCell>
        )}
        <StyledTableCell align='center'>
          {no < 1 ? index + 1 : index < 9 ? `${no}${index + 1}` : `${no + 1}0`}
        </StyledTableCell>
        {(filter === 'composer' || filter === 'completed') && user.nip !== '88888' && !isCreate && !isMonitoring && <StyledTableCell align='center'>{handleGetDateParaf()}</StyledTableCell>}
        <StyledTableCell align='center'>
          <ButtonContained
            size='small'
            onClick={(e) => handleOpenListApproval(e)}
          >
            Lihat
          </ButtonContained>
        </StyledTableCell>
        <StyledTableCell align='left'>{data.subject}</StyledTableCell>
        <StyledTableCell align='center'>
          <Stack
            direction='row'
            alignItems={'center'}
            justifyContent={'start'}
            textAlign={'start'}
            gap={3}
          >
            <Avatar
              src={data.composer.avatar_url}
              sx={{ width: '30px', height: '30px' }}
            ></Avatar>
            {data.composer.is_title
              ? data.composer.officer.nama
              : data.composer.nama}
          </Stack>
        </StyledTableCell>
        {filter === 'composer' && (
          <>
            <StyledTableCell align='center'>
              <Tooltip title="Lihat List Riwayat" placement='bottom'>
                <IconButton size='small' onClick={(e) => handleOpenListRiwayat(e)}>
                  <PendingActionsOutlined />
                </IconButton>
              </Tooltip>
            </StyledTableCell>

            <StyledTableCell align='center'>
              <Chip
                label={data.state === 'need_approval' ? 'Need Approval' : data.state === 'need_sign' ? 'Need Sign' : data.state === 'need_release' ? 'Need Release' : data.state}
                sx={{
                  backgroundColor: data.state === 'need_approval' ? yellow[100] : data.state === 'need_sign' ? blue[100] : data.state === 'need_release' ? indigo[100] : grey[100],
                  color: data.state === 'need_approval' ? yellow[700] : data.state === 'need_sign' ? blue[700] : data.state === 'need_release' ? indigo[700] : grey[700],
                  textTransform: 'capitalize',
                  fontWeight: 500
                }}
              />
            </StyledTableCell>
          </>
        )}
        {filter !== 'draft' && (
          <StyledTableCell align='center'>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2}>
              <Tooltip title={'Lihat Dokumen'} placement='top' arrow>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShowAttachment(index);
                  }}
                  style={{
                    minWidth: '30px',
                    backgroundColor: 'darkgrey',
                    marginRight: '5px',
                  }}
                >
                  <InsertDriveFile sx={{ fontSize: '14px', color: 'white' }} />
                </Button>
              </Tooltip>

              {filter === 'revisi' && (
                <Tooltip title={'Hapus Dokumen'} placement='top' arrow>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation()
                      setOpenModalDelete(true)
                    }}
                    style={{ minWidth: '30px', backgroundColor: red[500] }}>
                    <Delete sx={{ fontSize: '14px', color: 'white' }} />
                  </Button>
                </Tooltip>
              )}
            </Stack>
          </StyledTableCell>
        )}
      </StyledTableRow>

      <DialogListApprovalSK
        open={open}
        data={data}
        title={'Detail Penanggung Jawab'}
        handleClose={() => setOpen(false)}
      />

      <DialogListRiwayat
        open={openListRiwayat}
        data={data}
        title={'List Riwayat Aktifitas'}
        handleClose={() => setOpenListRiwayat(false)}
      />

      <DialogKonfirmasi
        open={openModalDelete}
        handleClose={handleDelete}
        labelPesan={'Hapus Dokumen'}
        isiPesan={`Apakah anda yakin akan menghapus dokumen ini?`}
        labelTombol='Ya'
      />
    </>
  );
};

export default ListViewItem;
ListViewItem.propTypes = {
  no: PropTypes.number,
  checked: PropTypes.any,
  lists: PropTypes.array,
  index: PropTypes.number,
  handleCheck: PropTypes.func,
  selectedRow: PropTypes.any,
  setSelectedRow: PropTypes.func,
  handleShowAttachment: PropTypes.func,
  key: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  tipeDokumen: PropTypes.string,
  isCreate: PropTypes.any,
  isMonitoring: PropTypes.any,
  setRefresh: PropTypes.func,
};
